<template>
    <div class="row" v-if="! showAddRecord && consultantRecords && consultantRecords.length > 0">
        <div class="col-lg-12">
            <div class="card shadow">
                <div class="table-responsive">
                    <base-table
                        class="table align-items-center table-flush"
                        thead-classes="thead-light"
                        tbody-classes="list"
                        :data="consultantRecords"
                    >
                        <template slot="columns">
                            <th width="2%">S/N</th>
                            <th>Staff Name <br> / Folio No</th>
                            <th>Previous Name</th>
                            <th>Department</th>
                            <th>Registration No</th>
                            <th>Rank /<br> Position</th>
                            <th width="5%">&nbsp;</th>
                        </template>

                        <template
                            slot-scope="{row, index}"
                        >
                        <td class="budget">
                            {{ pagination.from+index+1}}
                        </td>
                        <td class="text-capitalize">
                            {{ getFullName(row) }}<br>
                            <badge type="info" class="text-uppercase">
                                {{ row.folio_number ? ('MDCN/R/' + row.folio_number) : 'N/A' }}
                            </badge>
                        </td>
                        <td>
                            {{ row.previous_name ? row.previous_name : 'N/A' }}
                        </td>
                        <td>
                            {{ row.department ? row.department.name : 'N/A' }}
                        </td>
                        <td>
                            {{ row.reg_no }} 
                            <!-- <badge type="success">{{ row.aq_no }}</badge> -->
                        </td>
                        <td class="text-capitalize">
                            {{ row.rank ? row.rank : 'N/A' }}<br>
                            <badge type="primary">{{ row.position ? row.position : 'N/A' }}</badge>
                        </td>
                        <td>
                            <base-button
                                type="info" size="sm"
                                @click="$emit('editRecord', row)"
                            >
                                <i class="fa fa-pen"></i> Edit
                            </base-button>
                            <base-button
                                type="primary" size="sm"
                                @click="$emit('addQualification', row, true)"
                            >
                                <i class="fa fa-pen"></i> 
                                Qualifications ({{ row.qualifications.length }})
                            </base-button>
                            <base-button
                                type="danger" size="sm"
                                @click="$emit('deleteRecord', row.id)"
                            >
                                <i class="fa fa-trash"></i> Remove
                            </base-button>
                        </td>
                        </template>

                    </base-table>
                </div>

                <div
                    class="card-footer d-flex justify-content-end bg-transparent"
                    v-if="hasPagination"
                     @click="paginate"
                >
                    <base-pagination
                        :total="pagination.total"
                        align="center"
                        v-model="pagination.number"
                        :perPage="pagination.perPage"

                    >
                    </base-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        name: 'ConsultantRecords',
        props: ["consultantRecords", "showAddRecord", "pagination", "hasPagination", "paginate"],
        filters: {
            getDateFormat(value) {
                return moment(value).format('MMM, YYYY');
            }
        },
        methods: {
            getFullName(record) {
                if(record) {
                    let name = record.first_name;
                    name += record.other_name ? ' ' + record.other_name : '';
                    name += ' ' + record.surname;
                    return name;
                } else {
                    return 'N/A';
                }
            }
        }
    }
</script>